var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "station" },
    [
      _vm.formInfo.types !== 3
        ? _c(
            "div",
            { staticClass: "mb10 btn-box" },
            [
              _c(
                "el-upload",
                {
                  staticClass: "mr10 upload-real",
                  attrs: {
                    headers: _vm.myHeaders,
                    "http-request": _vm.uploadServerLog,
                    "show-file-list": false,
                    action: "##",
                  },
                },
                [
                  !_vm.percentShow
                    ? _c(
                        "el-button",
                        {
                          staticClass: "mb14",
                          attrs: { size: "small", type: "primary" },
                        },
                        [
                          _c("i", { staticClass: "el-icon-plus" }),
                          _vm._v("\n        添加文件\n      "),
                        ]
                      )
                    : _c("div", { staticClass: "addText" }, [
                        _c("img", {
                          staticClass: "l_gif",
                          attrs: {
                            alt: "",
                            src: require("../../../../assets/images/loading.gif"),
                          },
                        }),
                      ]),
                ],
                1
              ),
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _c(
        "el-table",
        { attrs: { data: _vm.fileData } },
        [
          _c("el-table-column", {
            attrs: {
              label: _vm.$t("hr.documentcover"),
              prop: "name",
              width: "80",
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    _vm.toSrcIcon(scope.row.name) !== "img"
                      ? _c("i", {
                          staticClass: "icon iconfont icon-cover pointer",
                          class: _vm.toSrcIcon(scope.row.name),
                          on: {
                            click: function ($event) {
                              return _vm.lookViewer(
                                scope.row.att_dir,
                                scope.row.name
                              )
                            },
                          },
                        })
                      : _c("img", {
                          staticClass: "img",
                          attrs: { src: scope.row.att_dir, alt: "" },
                        }),
                  ]
                },
              },
            ]),
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: {
              label: _vm.$t("customer.filename"),
              "min-width": "180",
              prop: "real_name",
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    _c("span", { staticClass: "over-text" }, [
                      _vm._v(_vm._s(scope.row.real_name)),
                    ]),
                  ]
                },
              },
            ]),
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: { label: "附件大小", "min-width": "180", prop: "att_size" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    _c("span", { staticClass: "over-text" }, [
                      _vm._v(_vm._s(_vm.formatBytesFn(scope.row.att_size))),
                    ]),
                  ]
                },
              },
            ]),
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: {
              label: _vm.$t("customer.uploaduser"),
              "min-width": "100",
              prop: "card.name",
            },
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: {
              label: _vm.$t("customer.uploaddate"),
              "min-width": "130",
              prop: "created_at",
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    _c("span", { staticClass: "over-text" }, [
                      _vm._v(
                        _vm._s(
                          _vm.$moment(scope.row.created_at).format("YYYY-MM-DD")
                        )
                      ),
                    ]),
                  ]
                },
              },
            ]),
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: {
              label: _vm.$t("public.operation"),
              fixed: "right",
              prop: "address",
              width: "180",
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    _vm.isFileImage(scope.row.name)
                      ? _c(
                          "el-button",
                          {
                            attrs: { type: "text" },
                            on: {
                              click: function ($event) {
                                return _vm.lookViewer(scope.row.att_dir)
                              },
                            },
                          },
                          [
                            _vm._v(
                              "\n          " +
                                _vm._s(_vm.$t("public.check")) +
                                "\n        "
                            ),
                          ]
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _c(
                      "el-button",
                      {
                        attrs: { type: "text" },
                        on: {
                          click: function ($event) {
                            return _vm.getFileLinkDownLoad(
                              scope.row.att_dir,
                              scope.row.name
                            )
                          },
                        },
                      },
                      [
                        _vm._v(
                          "\n          " +
                            _vm._s(_vm.$t("public.download")) +
                            "\n        "
                        ),
                      ]
                    ),
                    _vm._v(" "),
                    !_vm.isFileImage(scope.row.name)
                      ? _c(
                          "el-button",
                          {
                            attrs: { type: "text" },
                            on: {
                              click: function ($event) {
                                return _vm.handleLabel(scope.row)
                              },
                            },
                          },
                          [_vm._v("\n          重命名\n        ")]
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    !_vm.isFileImage(scope.row.name)
                      ? _c(
                          "el-button",
                          {
                            attrs: { type: "text" },
                            on: {
                              click: function ($event) {
                                return _vm.handleFileDelete(
                                  scope.row,
                                  scope.$index
                                )
                              },
                            },
                          },
                          [_vm._v("\n          删除")]
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.isFileImage(scope.row.name)
                      ? _c(
                          "el-dropdown",
                          [
                            _c(
                              "span",
                              {
                                staticClass:
                                  "el-dropdown-link el-button--text el-button ml10",
                              },
                              [
                                _vm._v(
                                  "\n            " +
                                    _vm._s(_vm.$t("hr.more")) +
                                    "\n            "
                                ),
                                _c("i", { staticClass: "el-icon-arrow-down" }),
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              "el-dropdown-menu",
                              { staticStyle: { "text-align": "center" } },
                              [
                                _vm.isFileImage(scope.row.name)
                                  ? _c(
                                      "el-dropdown-item",
                                      {
                                        nativeOn: {
                                          click: function ($event) {
                                            return _vm.handleLabel(scope.row)
                                          },
                                        },
                                      },
                                      [
                                        _vm._v(
                                          "\n              重命名\n            "
                                        ),
                                      ]
                                    )
                                  : _vm._e(),
                                _vm._v(" "),
                                _c(
                                  "el-dropdown-item",
                                  {
                                    nativeOn: {
                                      click: function ($event) {
                                        return _vm.handleFileDelete(
                                          scope.row,
                                          scope.$index
                                        )
                                      },
                                    },
                                  },
                                  [
                                    _vm._v(
                                      "\n              " +
                                        _vm._s(_vm.$t("public.delete"))
                                    ),
                                  ]
                                ),
                              ],
                              1
                            ),
                          ],
                          1
                        )
                      : _vm._e(),
                  ]
                },
              },
            ]),
          }),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "pagination" },
        [
          _c("el-pagination", {
            attrs: {
              "current-page": _vm.where.page,
              "page-size": _vm.where.limit,
              total: _vm.total,
              layout: "total, prev, pager, next, jumper",
            },
            on: { "current-change": _vm.pageChange },
          }),
        ],
        1
      ),
      _vm._v(" "),
      _c("image-viewer", {
        ref: "imageViewer",
        attrs: { "src-list": _vm.srcList },
      }),
      _vm._v(" "),
      _c(
        "el-dialog",
        {
          attrs: {
            "append-to-body": true,
            visible: _vm.dialogFormVisible,
            title: "修改文件名",
            width: "40%",
          },
          on: {
            "update:visible": function ($event) {
              _vm.dialogFormVisible = $event
            },
          },
        },
        [
          _c(
            "el-form",
            [
              _c(
                "el-form-item",
                { attrs: { label: "重命名：", "label-width": "100px" } },
                [
                  _c("el-input", {
                    attrs: { autocomplete: "off" },
                    model: {
                      value: _vm.real_name,
                      callback: function ($$v) {
                        _vm.real_name = $$v
                      },
                      expression: "real_name",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c(
                "el-button",
                {
                  on: {
                    click: function ($event) {
                      _vm.dialogFormVisible = false
                    },
                  },
                },
                [_vm._v("取 消")]
              ),
              _vm._v(" "),
              _c(
                "el-button",
                { attrs: { type: "primary" }, on: { click: _vm.putRealName } },
                [_vm._v("确 定")]
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }